export default "7387628034f09837.svg"